import { render, staticRenderFns } from "./bindalipay.vue?vue&type=template&id=b6a33212&"
import script from "./bindalipay.vue?vue&type=script&lang=js&"
export * from "./bindalipay.vue?vue&type=script&lang=js&"
import style0 from "./bindalipay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports